<template>
  <section >
   <vue-webrtc width="100%" roomId="roomId">
    </vue-webrtc>
  </section>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Testing/testing.vue